import { useQuery } from "@tanstack/react-query";
import { fetchData } from "../../services/api";
import { parkingQueryKeys } from "../../constants";
import { minutes } from "utils/time";
import {IParkingMachine} from "../../types/parkingMachine.type";

interface IUseGetParkingMachineParams {
    parkMachineCode: string;
}

export const useGetParkingMachine = (params: IUseGetParkingMachineParams) => {
    const { parkMachineCode } = params;

    return useQuery({
        queryKey: parkingQueryKeys.parkMachine.get(parkMachineCode),
        staleTime: minutes(5),
        gcTime: minutes(30),
        enabled: !!parkMachineCode,
        queryFn: async (): Promise<IParkingMachine> => {
            const response = await fetchData<IParkingMachine>("StreetParking/parkMachines/2", "GET", "url", {
                parkMachineCode,
            });

            return response[0];
        },
    });
};
